import { createFileRoute } from "@tanstack/react-router";
import { PlatformComplianceFormPage } from "@/components/compliance/PlatformComplianceFormPage";

export const Route = createFileRoute("/baja-servicio")({
  component: () => <PlatformComplianceFormPage type="BAJA_SERVICIO" />,
  head: () => ({
    meta: [
      { title: "Baja de Servicio — Structura" },
      { name: "description", content: "Solicitá la baja de tu suscripción a Structura." },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});
